export function normalizeUrl(url: string) {
  // strips the WP url
  return url.replace(new RegExp(`^http(s)?:\\/\\/${process.env.WP_SITE_DOMAIN.replace(/\./g, '\\.')}`), '');
}
